import { PlanPurchaseExperienceDialog } from '../PlanPurchaseExperienceDialog'
import { PromoAsset } from './PromoAsset/PromoAsset'
import { useLockModal } from '../../hooks/useLockModal/useLockModal'
import { usePromoCodeCoupon } from '../../hooks/usePromoCodeCoupon'
import React, { useRef } from 'react'

export const LockModal: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null)
  const { open, onClose, lockModalVariant, lockPlanType, graphic } = useLockModal(ref)

  const promoCouponProps = usePromoCodeCoupon(lockModalVariant)

  function handleSuccessfulCheckout(): void {
    onClose()
  }

  return (
    <>
      <PlanPurchaseExperienceDialog
        ref={ref}
        open={open}
        onClose={onClose}
        planType={lockPlanType}
        onSuccessfulCheckout={handleSuccessfulCheckout}
        promoHeading={graphic?.header}
        promoCouponProps={promoCouponProps}
        promoAsset={graphic?.src ? <PromoAsset graphic={graphic} /> : undefined}
        promoBackgroundImageUrl={graphic?.bg}
        promoHideCompanies={graphic?.hideCompanies}
      />
    </>
  )
}
